import { Route, Routes } from "react-router";
import AddOrderPage from "./add";

function OrdersPage() {
	return (
		<Routes>
			<Route path="/add" element={<AddOrderPage />} />
		</Routes>
	);
}

export default OrdersPage;
